import React, { useState } from "react";

const AccessWarningBanner = () => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 w-full bg-[#f8d7da] color-[#721c24] text-center p-[30px] border-b-[1px] border-[#f5c6cb] z-[100]">
      <button
        onClick={() => setVisible(false)}
        className="absolute top-3 right-3 text-xl cursor-pointer color-[#721c24]"
        aria-label="Close"
      >
        ✖
      </button>
      <p style={{ margin: 0 }}>
        <span>⚠️</span>
        Questo sito web è in costruzione. Questo non è il dominio finale e i
        servizi di pagamento non sono attualmente funzionanti. Si prega di non
        effettuare acquisti. <span>⚠️</span>
        <br />
        <span>⚠️</span> This website is under construction. This is not the
        final domain, and payment services are currently non-functional. Please
        do not make any purchases.
        <span>⚠️</span>
      </p>
    </div>
  );
};

export default AccessWarningBanner;
